import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./pages/About";
import Home from "./pages/Home";
import Packages from "./pages/Packages";
import Gallery from "./pages/Gallery";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import Contact from "./pages/Contact";
import Booking from "./pages/Booking";
import BookingConfirmed from "./pages/BookingConfirmed";
import { HelmetProvider } from "react-helmet-async";
import NotFound from "./pages/404";

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/gallery" element={<Gallery />} /> 
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/booking-confirmed" element={<BookingConfirmed />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <FloatingButtons />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;